import { Col, Container, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import './Footer.css'
import Brand from '../Brand/Brand'


const Footer = () => {
    return(
        <footer>
            <Container>
                <Row className='justify-content-center align-items-center'>
                    <Col md={6} className='d-flex justify-contents-center align-items-center'>
                        <Brand />
                    </Col>

                    <Col md={6} lg={4} className='d-flex justify-content-center flex-column'>
                        <h3>Contacto</h3>
                        <hr />
                        <a href='mailto:info@tefric.com'>
                            <FontAwesomeIcon icon={faEnvelope} />
                            <p>info@tefric.com</p>
                        </a>
                        <a href='tel:91 881 26 25' >
                            <FontAwesomeIcon icon={faPhone} />
                            <p>91 881 26 25</p>
                        </a>
                    </Col>
                </Row>
                <Row className='my-3 text-center'>
                    <Col>
                        <hr className='mx-auto' width='80'/>
                        <p>
                            &copy;2026 Copyright TEFRIC
                        </p>
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}

export default Footer